import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	title: {
		id: 'portfolio-3-onboarding.onboarding.spotlight-fields.title',
		defaultMessage: 'All about the details',
		description: 'The title for the spotlight',
	},
	content: {
		id: 'portfolio-3-onboarding.onboarding.spotlight-fields.content',
		defaultMessage:
			'Add or remove columns to highlight important planning information like issue dates, team assignments, estimates, and more.',
		description: 'The content for the spotlight',
	},
});
